import { render, staticRenderFns } from "./AlternateGSRPQualifier.vue?vue&type=template&id=8474ad5a&scoped=true&"
import script from "./AlternateGSRPQualifier.vue?vue&type=script&lang=ts&"
export * from "./AlternateGSRPQualifier.vue?vue&type=script&lang=ts&"
import style0 from "./AlternateGSRPQualifier.vue?vue&type=style&index=0&id=8474ad5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474ad5a",
  null
  
)

export default component.exports